// extracted by mini-css-extract-plugin
module.exports = {"fittty":"fittty__fittty___3I0LU"};